export default __webpack_public_path__ + "static/media/ExtraClouds.dae6b31d.webp";